import { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, FormMessage } from 'components/FormComponents';

const REDIRECT_DELAY_MS = 6000;

const ReplaceRefereeUnavailable = ({ onContinue }) => {
  const { t } = useTranslation();

  const onContinueRef = useRef(onContinue);
  onContinueRef.current = onContinue;

  useEffect(() => {
    const timeout = setTimeout(() => onContinueRef.current(), REDIRECT_DELAY_MS);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center p-8 relative gap-8">
      <div className="blob blob-1"></div>
      <div className="w-full md:w-1/2 lg:w-1/3 flex flex-col items-center justify-center gap-8 bg-neutral-1 rounded-3xl p-8 border border-neutral-4 z-10 shadow-2xl shadow-primary-4/20">
        <div
          className="rounded-3xl border border-neutral-4 w-full h-[350px] bg-cover bg-center bg-no-repeat mb-6"
          style={{ backgroundImage: 'url(/assets/images/reference-updated.svg)' }}></div>
        <div className="flex flex-col items-center justify-center gap-2">
          <h1 className="text-5xl font-bold text-neutral-7 text-center">
            {t('candidatePortal.referees.replaceUnavailableTitle')}
          </h1>
          <p className="text-neutral-6 text-2xl text-center">
            {t('candidatePortal.referees.replaceUnavailableMessage')}
          </p>
        </div>
        <FormMessage
          type="Brand"
          message={t('candidatePortal.referees.replaceUnavailableRedirect')}
          closeable={false}
          noMargin
        />
        <Button type="gradient" className="w-full" onClick={onContinue}>
          {t('candidatePortal.referees.goToDashboard')}
        </Button>
      </div>
    </div>
  );
};

export default ReplaceRefereeUnavailable;
